import Decimal from 'decimal.js';

import { toCompactMoney, toMoney, toMoneyWithCentsIfCents } from 'utils/caseing';

// `Decimal.Value` (not `number`) since rewards API responses often carry cents as strings.

export function centsToDollars(cents: Decimal.Value): number {
    return new Decimal(cents).dividedBy(100).toNumber();
}

export function centsToMoney(cents: Decimal.Value, includeCents = true): string {
    return toMoney(centsToDollars(cents), includeCents);
}

export function centsToMoneyWithCentsIfCents(cents: Decimal.Value): string {
    return toMoneyWithCentsIfCents(centsToDollars(cents));
}

export function centsToCompactMoney(cents: Decimal.Value): string {
    return toCompactMoney(centsToDollars(cents));
}
